<template>
  <Layout>
    <Column
      :size="!horizontal ? '12' : (12 / optionsPerLine).toString()"
      :key="index"
      v-for="(item, index) in options"
    >
      <!--      <input-->
      <!--          :disabled="disabled"-->
      <!--          :id="item.value"-->
      <!--          :name="name"-->
      <!--          :readonly="readonly"-->
      <!--          :value="item.value"-->
      <!--          @input="onInput"-->
      <!--          class="pw-radio-button"-->
      <!--          type="radio"-->
      <!--          v-model="computedValue"-->
      <!--          v-on="$listeners"-->
      <!--      />-->
      <div class="pw-radio-button">
        <PrettyRadio
          class="pw-inputradio"
          :class="internalClass"
          :name="name"
          :value="item.value"
          v-model="computedValue"
          :disabled="disabled || readonly"
          toggle
        >
          <i class="icon mdi mdi-radiobox-marked" slot="extra"></i>
          <i class="icon mdi mdi-radiobox-blank" slot="off-extra"></i>
        </PrettyRadio>
        <label
          @click="!readonly && !disabled ? (computedValue = item.value) : ''"
          :for="name"
          class="pw-labelradio"
          >{{ item.label }}</label
        >
      </div>
    </Column>
  </Layout>
</template>

<script>
import PrettyRadio from 'pretty-checkbox-vue/radio';
import Layout from './Layout.vue';
import Column from './Column.vue';

export default {
  name: 'RadioButtons',
  components: {
    Layout,
    Column,
    PrettyRadio,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String],
    },
    required: {
      type: [Boolean, String],
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    optionsPerLine: {
      type: Number,
      default: 2,
    },
    xl: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  mounted() {
    this.changeName();
    this.changeRequired();
  },
  data() {
    return {
      newValue: this.value,
      disabled: false,
      checked: false,
    };
  },
  methods: {
    changeName() {
      if (this.$parent.changeName) {
        this.$parent.changeName(this.name);
      }
    },
    changeRequired() {
      if (this.$parent.changeRequired) {
        this.$parent.changeRequired(this.required);
      }
    },
  },
  computed: {
    internalClass() {
      const classCSS = { 'mdi-36px': this.xl };
      const className = `is-${this.color}`;
      classCSS[className] = true;
      return className;
    },
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        this.$emit('input', value);
        this.newValue = value;
      },
    },
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    name() {
      this.changeName();
    },
    required() {
      this.changeRequired();
    },
  },
};
</script>

<style lang="scss">
$main: #5186ff;

$primary: #6ae1c8;
$primary-hover: #6ed2bd;
$primary-selected: #51c6ae;
$primary-disabled: #97decf;

$secondary: #5b89f2;
$secondary-hover: #5d86e1;
$secondary-selected: #5079d8;
$secondary-disabled: #8cabf3;

$terciary: #707070;
$terciary-hover: #a7b1b8;
$terciary-selected: #a0a4a7;
$terciary-disabled: #c2c2c2;

$quinary: #f25555;
$quinary-hover: #e14f4f;
$quinary-selected: #e54040;
$quinary-disabled: #ec9696;

$success: #19bf95;
$success-hover: #19bf95;
$success-selected: #19bf95;
$success-disabled: #19bf95;

$color1: #9f9f9f;
$color2: #ffc848;
$color3: #6ae1c8;
$color4: #19bf95;
$color5: #5186ff;
$color6: #707070;
$color7: #f25555;

$list: 'primary', 'secondary', 'terciary', 'quinary', 'success', 'color1', 'color2', 'color3',
  'color4', 'color5', 'color6', 'color7';

$colors: (
  primary: $primary,
  secondary: $secondary,
  terciary: $terciary,
  quinary: $quinary,
  success: $success,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-hover: (
  primary: $primary-hover,
  secondary: $secondary-hover,
  terciary: $terciary-hover,
  quinary: $quinary-hover,
  success: $success-hover,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-selected: (
  primary: $primary-selected,
  secondary: $secondary-selected,
  terciary: $terciary-selected,
  quinary: $quinary-selected,
  success: $success-selected,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

$colors-disabled: (
  primary: $primary-disabled,
  secondary: $secondary-disabled,
  terciary: $terciary-disabled,
  quinary: $quinary-disabled,
  success: $success-disabled,
  color1: $color1,
  color2: $color2,
  color3: $color3,
  color4: $color4,
  color5: $color5,
  color6: $color6,
  color7: $color7,
);

@mixin variantColors($outlined: false) {
  @each $var in $list {
    @if $outlined {
      &.is-#{$var}-outlined {
        border-color: map-get($colors, $var);
        color: map-get($colors, $var);
        background-color: transparent;
        &:hover {
          border-color: map-get($colors-hover, $var);
        }
        &:focus,
        &:active {
          border-color: map-get($colors-selected, $var);
        }
      }
    }
    &.is-#{$var} {
      background-color: map-get($colors, $var);
      border-color: map-get($colors, $var);
      color: white;
      &:hover {
        background-color: map-get($colors-hover, $var);
      }
      &:focus,
      &:active {
        background-color: map-get($colors-selected, $var);
      }
      &:disabled {
        background-color: map-get($colors-disabled, $var);
      }
    }
  }
}
@import '~pretty-checkbox/src/pretty-checkbox.scss';
.pretty {
  margin-right: 0 !important;
}
.pretty .state label {
  display: none;
}
.pw-radio-button {
  i {
    font-size: 24px;
  }

  .is-primary {
    .mdi-radiobox-marked {
      color: $primary;
    }
  }
  .is-secondary {
    .mdi-radiobox-marked {
      color: $secondary;
    }
  }
  .is-terciary {
    .mdi-radiobox-marked {
      color: $terciary;
    }
  }
  .is-quinary {
    .mdi-radiobox-marked {
      color: $quinary;
    }
  }
  .is-success {
    .mdi-radiobox-marked {
      color: $success;
    }
  }
  .mdi-checkbox-blank-outline {
    color: #bdc6cc;
  }
}
.pw-inputradio {
  vertical-align: middle;
  display: table-cell;
  padding-right: 5px;
}

.pw-labelradio {
  vertical-align: middle;
  display: table-cell;
}

.pw-inputradio {
  input {
    &:disabled ~ .state {
      .icon {
        color: #bdc6cc !important;
        cursor: not-allowed;
      }
    }
  }
}
.pw-radio-buttons {
  display: inline;
  position: relative;
  width: 100%;
}
</style>
